<div class="background" *ngIf="showModal">
    <div class="modal">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
</div>